import React, {useEffect} from 'react';

import { useTranslation } from 'react-i18next';

import closedEye from 'assets/images/closedEye.svg';
import openedEye from 'assets/images/header-eye.svg';
import {useDispatch} from "react-redux";
import {getCurrentSellerStatistic} from "../../redux/sellers/actions";

function CardStatistic({ seller }) {
  const [showStatistic, setShowStatistic] = React.useState(true);
  const [stat, setStat] = React.useState({});

  const { t } = useTranslation();

  const dispatch = useDispatch();
  useEffect(() => {
    if (!seller?.info.data?.id || seller?.statistic) {
      return
    }
    dispatch(getCurrentSellerStatistic(seller?.info.data?.id));
  }, [seller?.info.data?.id]);

  useEffect(() => {
    setStat(seller?.statistic);
  }, [seller?.statistic]);

  return (
    <div className="bg-white shadow-lg rounded-sm border border-gray-200 text-sm">
      <div className="flex flex-col h-full px py-5">
        <div className="flex items-center justify-between px-5 mb-2">
          <h3 className="text-lg text-black text-left font-semibold text-base">
            {t('company_statistic')}
          </h3>
          <button onClick={() => setShowStatistic(!showStatistic)} className="bg-transparent">
            {<img src={!showStatistic ? closedEye : openedEye} alt="show" />}
          </button>
        </div>
        <div className={`px-4 ${showStatistic ? '' : 'filter blur'}`}>
          <div className="flex justify-between">
            <div className="p-2" style={{ color: '#000' }}>
              {t('linked_accountss')}
            </div>
            <div className="p-2 font-bold" style={{ color: '#000' }}>
              {stat && stat.sellersMarketsCount}
            </div>
          </div>
          <div style={{ backgroundColor: '#eef2ff' }} className="flex justify-between">
            <div className="p-2" style={{ color: '#000' }}>
              {t('product_cardss')}
            </div>
            <div className="p-2 font-bold" style={{ color: '#000' }}>
              {stat && stat.productsCount}
            </div>
          </div>
          <div className="flex justify-between">
            <div className="p-2" style={{ color: '#000' }}>
              {t('items_sold')}
            </div>
            <div className="p-2 font-bold" style={{ color: '#000' }}>
              {stat && stat.soldProductsCount}
            </div>
          </div>
          <div style={{ backgroundColor: '#eef2ff' }} className="flex  justify-between">
            <div className="p-2" style={{ color: '#000' }}>
              {t('amount_sold')}, &#8381;
            </div>
            <div className="p-2 font-bold" style={{ color: '#000' }}>
              {stat && stat.soldProductsSum}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardStatistic;
